import React, { useReducer } from 'react';
import stepStore from '../stores/stepStore';

const stepReducer = (step, action) => {
  switch (action.type) {
    case 'NEXT_STEP':
      stepStore.update(state => { state.index = step + 1; });
      return step + 1;
    case 'PREV_STEP':
      stepStore.update(state => { state.index = step - 1; });
      return step > 0 ? step - 1 : step;
    case 'SET_STEP': {
      let stepIndex;

      action.steps.forEach(({ props }, i) => { if (props.stepKey === action.step) stepIndex = i; });

      if (stepIndex) step = stepIndex;

      stepStore.update(state => { state.index = step; });

      return step;
    }
    default:
      return step;
  }
};

const withWizard = wizardSteps => WrappedComponent => props => {
  const { enable_firebase_authentication } = props;
  const steps = wizardSteps(enable_firebase_authentication);

  const [step, dispatch] = useReducer(stepReducer, 0);
  const lastStep = step === (steps.length - 1);

  return (
    <WrappedComponent
      steps={steps}
      stepElement={(steps[step])}
      stepDispatch={dispatch}
      lastStep={lastStep}
      currentStepIndex={step}
      {...props}
    />
  );
};

export default withWizard;
